/**
 * 系统错误日志常量定义
 * 
 * @module types/error-log/constants
 * @description 定义错误日志系统的常量和映射关系
 * 
 * @backend-source
 * - backend/app/Modules/System/Models/ErrorLog.php (LEVEL_LABELS 常量)
 * 
 * @attention
 * - 常量名使用 UPPER_SNAKE_CASE
 * - 映射关系必须与后端完全一致
 * 
 * @last-updated 2025-10-20
 */

import { ErrorLevel } from './enums'

/**
 * 错误级别标签映射
 * 
 * @backend ErrorLog::LEVEL_LABELS
 */
export const ERROR_LEVEL_LABELS: Record<ErrorLevel, string> = {
  [ErrorLevel.EMERGENCY]: '紧急',
  [ErrorLevel.ALERT]: '警报',
  [ErrorLevel.CRITICAL]: '严重',
  [ErrorLevel.ERROR]: '错误',
  [ErrorLevel.WARNING]: '警告',
  [ErrorLevel.NOTICE]: '注意',
  [ErrorLevel.INFO]: '信息',
  [ErrorLevel.DEBUG]: '调试',
}

/**
 * 错误级别颜色映射（用于UI展示）
 */
export const ERROR_LEVEL_COLORS: Record<ErrorLevel, string> = {
  [ErrorLevel.EMERGENCY]: 'red',
  [ErrorLevel.ALERT]: 'red',
  [ErrorLevel.CRITICAL]: 'red',
  [ErrorLevel.ERROR]: 'orange',
  [ErrorLevel.WARNING]: 'yellow',
  [ErrorLevel.NOTICE]: 'blue',
  [ErrorLevel.INFO]: 'green',
  [ErrorLevel.DEBUG]: 'gray',
}

/**
 * 错误级别严重程度排序（用于筛选和排序）
 * 数值越大，级别越高
 */
export const ERROR_LEVEL_SEVERITY: Record<ErrorLevel, number> = {
  [ErrorLevel.EMERGENCY]: 8,
  [ErrorLevel.ALERT]: 7,
  [ErrorLevel.CRITICAL]: 6,
  [ErrorLevel.ERROR]: 5,
  [ErrorLevel.WARNING]: 4,
  [ErrorLevel.NOTICE]: 3,
  [ErrorLevel.INFO]: 2,
  [ErrorLevel.DEBUG]: 1,
}

/**
 * 运行环境标签映射
 */
export const ENVIRONMENT_LABELS: Record<string, string> = {
  local: '本地',
  testing: '测试',
  staging: '预发布',
  production: '生产',
}

/**
 * 默认统计周期选项
 */
export const STATISTICS_PERIOD_OPTIONS = [
  { value: 'today', label: '今天' },
  { value: 'week', label: '本周' },
  { value: 'month', label: '本月' },
  { value: 'year', label: '本年' },
] as const

/**
 * 默认排序字段选项
 */
export const SORT_BY_OPTIONS = [
  { value: 'created_at', label: '创建时间' },
  { value: 'level', label: '错误级别' },
  { value: 'occurrence_count', label: '出现次数' },
  { value: 'last_occurred_at', label: '最后出现时间' },
] as const

